/**
 * Main topic for announcement events
 *
 * @public
 */
export const EVENTS_TOPIC_ANNOUNCEMENTS = 'announcements';

/**
 * Event action for creating an announcement
 *
 * @public
 */
export const EVENTS_ACTION_CREATE_ANNOUNCEMENT = 'create_announcement';

/**
 * Event action for updating an announcement
 *
 * @public
 */
export const EVENTS_ACTION_UPDATE_ANNOUNCEMENT = 'update_announcement';

/**
 * Event action for deleting an announcement
 *
 * @public
 */
export const EVENTS_ACTION_DELETE_ANNOUNCEMENT = 'delete_announcement';

/**
 * Event action for creating a category
 *
 * @public
 */
export const EVENTS_ACTION_CREATE_CATEGORY = 'create_category';

/**
 * Event action for deleting a category
 *
 * @public
 */
export const EVENTS_ACTION_DELETE_CATEGORY = 'delete_category';

/**
 * Channel name for new announcement signals
 *
 * @public
 */
export const SIGNALS_CHANNEL_ANNOUNCEMENTS = 'announcements:new';

/**
 * Channel name for new announcement signals
 *
 * @public
 */
export const RESOURCE_TYPE_ANNOUNCEMENT_ENTITY = 'announcement';

/**
 * navitems name
 *
 * @public
 */
export const NAVIGATION_ITEMS = {
  ALL_UPDATES: { label: 'All Updates', value: 'all-updates' },
  XELERATE_UPDATES: { label: 'XELERATE', value: 'group:default/admins' },
  MY_UPDATES: { label: 'My Group Updates', value: 'my-group-updates' },
  SUB_UPDATES: { label: 'Subscriptions', value: 'sub-updates' },
};

export const SIGNALS_CHANNEL_ANNOUNCEMENTS_READ = 'announcements:read';
export const SIGNALS_CHANNEL_SUBSCRIPTION = 'announcements:susbcribed';
export const SIGNALS_CHANNEL_UNSUBSCRIPTION = 'announcements:unsubscribed';

export const PLUGIN_ANNOUNCEMENTS_TITLES = {
  NEW_GROUP_UPDATE: 'New Update in Your Group',
  NEW_UPDATE_IN_SUBSCRIPTION_LIST: 'New Update',
  UPDATE_EDITED: 'Update Modified',
  USER_SUBSCRIBED_TO_LIST: 'New Subscriber',
  USER_UNSUBSCRIBED_FROM_SUBSCRIPTION: 'User Unsubscribed',
  UPDATE_LIST_DELETED: 'Update List Deleted',
};

export const NOTIFICATION_TITLES = {
  ...PLUGIN_ANNOUNCEMENTS_TITLES,
};

export const NOTIFICATION_DESCRIPTIONS_BY_TITLE: Record<
  (typeof NOTIFICATION_TITLES)[keyof typeof NOTIFICATION_TITLES],
  string
> = {
  [NOTIFICATION_TITLES.NEW_GROUP_UPDATE]:
    'Get notified when someone in your group creates an update',
  [NOTIFICATION_TITLES.NEW_UPDATE_IN_SUBSCRIPTION_LIST]:
    'Get notified when a new update is posted',
  [NOTIFICATION_TITLES.UPDATE_EDITED]:
    'Get notified when an existing update is modified',
  [NOTIFICATION_TITLES.USER_SUBSCRIBED_TO_LIST]:
    'Get notified when someone subscribes to any of your update lists',
  [NOTIFICATION_TITLES.USER_UNSUBSCRIBED_FROM_SUBSCRIPTION]:
    'Get notified when someone unsubscribes from your update list',
  [NOTIFICATION_TITLES.UPDATE_LIST_DELETED]:
    'Get notified when an update list you subscribed to is deleted',
};

export const validNotificationTopicsMapping: Record<string, string[]> = {
  'plugin:announcements': Object.values(PLUGIN_ANNOUNCEMENTS_TITLES),
};

/**
 * to hide notification setting from FE and restrict it in BE
 */
export const hideNotificationMapping: Record<string, string[]> = {
  'plugin:announcements': [
    PLUGIN_ANNOUNCEMENTS_TITLES.USER_SUBSCRIBED_TO_LIST,
    PLUGIN_ANNOUNCEMENTS_TITLES.USER_UNSUBSCRIBED_FROM_SUBSCRIPTION,
    PLUGIN_ANNOUNCEMENTS_TITLES.UPDATE_LIST_DELETED,
  ],
};
